import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'V3SideBarGroup',
  props: {
    title: null,
    showMinimized: { type: Boolean }
  },
  setup(__props: any) {



return { __sfc: true, }
}

})